exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-module=ZoomImages]{display:inline-block}[data-module=ZoomImages] .module-wrapper{width:auto;position:relative;cursor:pointer;cursor:zoom-in}[data-module=ZoomImages] .module-wrapper.no-zoom{cursor:default}[data-module=ZoomImages] button.zoom-button{position:absolute;top:10px;right:10px;padding:0;margin:0;background:none;border:none;opacity:.5;transition:opacity .3s}[data-module=ZoomImages] button.zoom-button:hover{opacity:1}p [data-module=ZoomImages]{float:left;margin-right:10px;max-width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/zoom-images/styles.scss
// module id = 654
// module chunks = 0